module.exports = __webpack_public_path__ + "img/bargainAmountDepartment.2df15787.svg";